module.exports = __webpack_public_path__ + "img/Completed-close.548127b3.svg";